<!-- 首页 -->
<template>
  <div>
    <home-menu></home-menu>
    <div class="main">
      <router-view></router-view>
    </div>
    <home-bottom></home-bottom>
    <!-- 提醒用户视频辅导时间 -->
    <zlr-modal v-model="surplusModal"
               :mask-closable=false
               @on-change="surplusChangeHandle">
      <div class="coach-time-modal">
        <h2>{{surplusTime>=0? `距离您与${surplusData.mentorType}导师${surplusData.mentorName}的视频辅导只剩下`:`您与${surplusData.mentorType}导师${surplusData.mentorName}的视频辅导已经开始`}}</h2>
        <div class="surplus"
             :class="[surplusTime<0?'waring':'']">{{surplusTimeCon}}</div>
        <div>
          <Button class="btn-close"
                  @click="surplusCloseHandle">关闭</Button>
          <Button class="btn-in"
                  @click="handleEnterCoach">进入辅导</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>
<script>
// api
import { getAppRecentlyResultTime } from '@/api/appointment'
import './home.less'
// components
import HomeMenu from './home-menu'
import HomeBottom from './home-bottom'
import ZlrModal from '_c/modal/modal'
// 常量
// let intervalTime = 5000000
export default {
  name: 'home',
  components: {
    HomeBottom,
    HomeMenu,
    ZlrModal
  },
  data () {
    return {
      surplusModal: false,
      intervalTime: '',
      surplusTime: null,
      surplusTimeCon: '',
      surplusData: {}
    }
  },
  computed: {},
  mounted () {
    this.getCoachTime()
  },
  methods: {
    getCoachTime () {
      getAppRecentlyResultTime({}).then(res => {
        if (res.data.model) {
          this.surplusData = res.data.model
          let time = res.data.model.resultTime
          if (!(this.$route.path === '/mentor/zoom' && Number(this.$route.query.id) === this.surplusData.id)) {
            this.surplusModal = true
          }
          this.surplusTime = (time - Date.now()) / 1000
          this.surplusTimeHandle()
          this.setIntervalHandle()
        }
      })
    },
    surplusTimeHandle () {
      let time = Math.abs(Math.floor(this.surplusTime))
      let minutes = this.completion(Math.floor(time / 60))
      let seconds = this.completion(time % 60)
      this.surplusTimeCon = `00:${minutes}:${seconds}`
    },
    setIntervalHandle () {
      this.intervalTime = setInterval(() => {
        this.surplusTime--
        this.surplusTimeHandle()
      }, 1000)
    },
    completion (num) {
      if (num < 10) {
        num = `0${num}`
      }
      return num
    },
    surplusChangeHandle (b) {
      if (!b) {
        clearInterval(this.intervalTime)
      }
    },
    // 关闭
    surplusCloseHandle () {
      this.surplusModal = false
    },
    // 进入辅导
    handleEnterCoach () {
      if (this.surplusData.type === 'INTERVIEW') {
        this.$router.push({
          name: 'project-interview-zoom',
          params: {
            id: this.surplusData.projectId
          },
          query: {
            id: this.surplusData.id
          }
        })
      } else {
        this.$router.push({
          name: 'mentor-zoom',
          query: {
            id: this.surplusData.id
          }
        })
      }
      this.surplusModal = false
    }
  },
  beforeDestroy () {
    clearInterval(this.intervalTime)
  }
}
</script>
<style lang='less' scoped>
.main {
  min-height: calc(100vh - 265px);
}
</style>
